module.exports = vendor_20f1c10d8dc978738a8e;